var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignShopper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20335",
    "data-name": "Group 20335",
    transform: "translate(7088.463 -23940.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20292",
    "data-name": "Group 20292",
    transform: "translate(-7088.09 23940.266)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_158",
    "data-name": "Ellipse 158",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(-0.373)",
    fill: "#14b7dd",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "buyer",
    transform: "translate(-7120.913 23946.383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20291",
    "data-name": "Group 20291",
    transform: "translate(40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112467",
    "data-name": "Path 112467",
    d: "M53.753,12.607a1.424,1.424,0,0,0-.488-1.069,1.135,1.135,0,0,0,.2-.645V10.74a1.135,1.135,0,0,0-.059-.361L52.19,6.725a2.289,2.289,0,0,0-2.174-1.567h-.948a2.574,2.574,0,0,0,.961-2.006v-.93A2.224,2.224,0,0,0,47.807,0h-.714a2.224,2.224,0,0,0-2.222,2.222v.93a2.574,2.574,0,0,0,.961,2.006h-.948a2.289,2.289,0,0,0-2.174,1.567l-1.218,3.654a1.137,1.137,0,0,0-.059.361v.153a1.133,1.133,0,0,0,.2.645,1.424,1.424,0,0,0-.488,1.069H40v4.584h4.584v.573h5.731v-.573H54.9V12.607Zm-.573,0H51.461a.858.858,0,0,1,.356-.693,1.14,1.14,0,0,0,.509.12,1.128,1.128,0,0,0,.5-.12A.857.857,0,0,1,53.18,12.607Zm-.316-2.046a.561.561,0,0,1,.029.179v.153a.562.562,0,0,1-.131.358,1.307,1.307,0,0,0-.879,0A.575.575,0,0,1,51.8,11.1l-1.072-2.68,1.222-.611Zm-1.481.971a1.424,1.424,0,0,0-.5,1.075h-.573V8.938l.952,2.379A1.144,1.144,0,0,0,51.384,11.532Zm-5.94-9.311A1.65,1.65,0,0,1,47.093.573h.714a1.65,1.65,0,0,1,1.649,1.649v.111a2.189,2.189,0,0,1-.413-.46.984.984,0,0,0-.821-.44H46.678a.991.991,0,0,0-.83.454,2.122,2.122,0,0,1-.4.446Zm0,.93V3.029a2.731,2.731,0,0,0,.891-.84.412.412,0,0,1,.344-.184h1.544a.421.421,0,0,1,.354.2,2.7,2.7,0,0,0,.88.824v.123a2.006,2.006,0,1,1-4.011,0Zm3.081,2.579a1.3,1.3,0,0,1-2.151,0h2.151Zm-6.52,5.01a.561.561,0,0,1,.029-.179l.916-2.748,1.222.611L43.1,11.1a.569.569,0,0,1-.085.146,1.3,1.3,0,0,0-.878,0,.562.562,0,0,1-.131-.358Zm.069,1.174a1.119,1.119,0,0,0,1.008,0,.857.857,0,0,1,.356.693H41.719A.857.857,0,0,1,42.074,11.914Zm2.51,4.7H40.573V13.18h.573v.573h.573V13.18h1.719v.573h.573V13.18h.573Zm0-4.011h-.573a1.423,1.423,0,0,0-.5-1.075,1.155,1.155,0,0,0,.117-.215l.952-2.379Zm2.579,4.584H45.158v-.573h2.006Zm2.579,0H47.736v-.573h2.006Zm0-1.146H47.736V12.894h-.573v3.152H45.158V13.151a1.435,1.435,0,0,0,1.146-1.4H48.6a1.435,1.435,0,0,0,1.146,1.4Zm-4.584-3.491v-.807h.573A.858.858,0,0,1,45.158,12.555Zm4.584,0a.858.858,0,0,1-.573-.807h.573Zm0-5.391v4.011H45.158V7.163h-.573v.231l-.2.5-1.253-.626.119-.358a1.718,1.718,0,0,1,1.631-1.175h.881a1.811,1.811,0,0,0,3.369,0h.881a1.717,1.717,0,0,1,1.631,1.176l.119.358-1.253.626-.2-.5V7.163Zm4.584,9.455H50.315V13.18h.573v.573h.573V13.18H53.18v.573h.573V13.18h.573Z",
    transform: "translate(-40)",
    fill: "#76747f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignShopper);
export default __webpack_public_path__ + "static/media/AssignShopper.e1cfa4db3d53002e9f7009a6906091b1.svg";
export { ForwardRef as ReactComponent };